export const LOAD_FORMS = 'LOAD_FORMS';
export const SET_FORM_PAGINATION = 'SET_FORM_PAGINATION';
export const SET_FORM_SORT = 'SET_FORM_SORT';
export const SET_FORM_FILTERS = 'SET_FORM_FILTERS';
export const RESET_FORM_FILTERS = 'RESET_FORM_FILTERS';
export const DELETE_FORM = 'DELETE_FORM';
export const UPDATE_FORM = 'UPDATE_FORM';
export const SET_CHECKED_FORMS = 'SET_CHECKED_FORMS';
